import styled from "styled-components";
import { Card, Form, Accordion } from "react-bootstrap";
import { Tabs, Input, Select } from "antd";
import headerbg from "../../assets/header-bg.png";

export const MainCollectionDetails = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  .filterFooter {
    .buyTxt {
      font-family: "Barlow";
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      color: #1a1a1a;
    }
  }
  .filterDiv {
    .priceRange {
      font-family: "Barlow";
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      color: #1a1a1a;
    }

    .minMaxMain {
      display: flex;
      flex-direction: column;
      gap: 0.7rem;
      flex: 1;

      .form-select {
        border-radius: 10px;
        border: 1px solid #7f8c8d;
        box-shadow: none;
      }
    }

    .inputWrapper {
      display: flex;
      justify-content: center;
      gap: 0.5rem;

      input {
        height: 32px;
        width: 48%;
        border-radius: 10px;
        border: 1px solid #7f8c8d;
        padding: 0.5rem;
        ::placeholder {
          padding-left: 1rem !important;
        }
      }
    }
    .filterInput {
      height: 32px;
      border-radius: 10px;
      margin-top: 2rem;
      border: 1px solid #7f8c8d;
      width: 100%;
      padding: 0.5rem;
      ::placeholder {
        padding-left: 1rem !important;
      }
    }
  }
`;

export const MainCollectionCard = styled(Card)`
  width: 215px;
  background: #fff;
  padding: 0;
  border: none;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.1))
    drop-shadow(-4px -4px 10px rgba(0, 0, 0, 0.1));
  overflow: hidden;

  &:hover .buyBtn {
    visibility: visible;
  }

  .header {
    display: flex;
    justify-content: space-between;
    margin: 2px 10px 8px 10px;
    -ms-transform: translateY(5px);
    -webkit-transform: translateY(5px);
    -moz-transform: translateY(5px);
    -o-transform: translateY(5px);

    z-index: 1;
    overflow: hidden !important;

    P {
      font-family: "Barlow";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      color: #000000;
      text-transform: capitalize;
    }
  }

  .cardInfo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 5px;
    padding-top: 5px;
    padding-bottom: 5px;

    p {
      font-family: "Barlow";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      margin-top: -7px;
      color: #000000;
      -ms-transform: translateY(8px);
      -webkit-transform: translateY(8px);
      -moz-transform: translateY(8px);
      -o-transform: translateY(8px);
    }
  }

  .buyBtn {
    visibility: hidden;
    padding: 8px 18px;
    background: #d35400;
    border-radius: 10px;
    border: none;
    color: white;
    font-family: "Barlow";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;

    &:hover {
      background: #e67e22;
    }
  }

  .cardImgDiv {
    overflow: hidden;
  }

  @media (max-width: 990px) {
    width: 100%;
  }

  @media (max-width: 420px) {
    width: 300px;
  }

  @media (max-width: 322px) {
    width: 100%;
  }
`;

export const ToggleButton = styled(Form.Check)`
  font-size: 1.3rem;
  transform: translateX(20px);
  #mySwitch {
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='10' cy='10' r='10' fill='%23D4D4D4'/%3E%3C/svg%3E%0A") !important;

    background-color: #1a1a1a;
  }
  #mySwitch:checked {
    background-color: #d35400;
  }
`;

export const CardImage = styled(Card.Img)`
  @media (max-width: 420px) {
    height: 100%;
  }

  overflow: hidden;

  &:hover {
    transform: scale(1.3, 1.2);
    transition: all 0.3s;
  }
`;

export const CardMainFlex = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;

  @media (min-width: 992px) {
    .cardItem {
      transform: translateX(40px);
    }
    .cardItem2 {
      transform: translateX(15px);
    }
  }

  @media (max-width: 1367px) {
    margin-left: 3rem;
  }

  @media (max-width: 1280px) {
    margin-left: 3.5rem;
  }
  @media (max-width: 1200px) {
    margin-left: 5.5rem;
  }

  @media (max-width: 767px) {
    margin-left: 1rem;
  }

  @media (max-width: 500px) {
    margin-left: 0.5rem;
  }
  @media (max-width: 420px) {
    margin-left: 3rem;
  }

  @media (max-width: 393px) {
    margin-left: 2rem;
  }
  @media (max-width: 372px) {
    margin-left: 1.3rem;
  }
  @media (max-width: 362px) {
    margin-left: 0.7rem;
  }
  @media (max-width: 340px) {
    margin-left: 0.5rem;
  }
  @media (max-width: 322px) {
    margin-left: 0rem;
  }
`;

export const CollapseMain = styled(Accordion)`
  background: transparent !important;
  width: 100%;

  .accordion-button {
    background-color: none !important;
    border: none;
    box-shadow: none !important;
  }

  &.accordion-item {
    border: none !important;
    background-color: transparent !important;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 0 0.7rem;

  .divTab {
    flex: 30%;

    display: flex;
    align-items: center;
    gap: 0.5rem;

    .filterIcon {
      transform: translateY(-5px);
      color: #d35400;
      cursor: pointer;
      &.active {
        color: #1a1a1a;
      }
    }
  }

  .searchMain {
    flex: 70%;
    display: flex;
    align-items: center;
    gap: 1.5rem;
    .searchDiv {
      flex: 72%;
    }
    .selectDiv {
      flex: 28%;
    }

    @media (max-width: 467px) {
      flex-wrap: wrap;

      margin-bottom: 1rem;
    }
  }
`;

export const FilterTab = styled(Tabs)`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #000 !important;
  }

  .ant-tabs-ink-bar {
    background-color: #d35400 !important;
  }

  .ant-tabs-nav:before {
    border-bottom: none !important;
  }
`;

export const FilterTabPanel = styled(Tabs.TabPane)`
  &.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #000 !important;
  }
`;

// searchInput

export const SearchInput = styled(Input)`
  border: 1px solid #7f8c8d;
  border-radius: 10px;
  padding: 0.3rem;
  & > ::placeholder {
    padding-left: 1rem;
    vertical-align: center;

    font-size: 16px;
    line-height: 30px;

    color: #7f8c8d;
  }
`;

export const PriceSelect = styled(Select)`
  width: 100%;
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-radius: 10px !important;
    border: 1px solid #7f8c8d !important;
  }
`;
export const PriceSelectOption = styled(Select.Option)``;

// Tabs Filter Above Row

// HeroSection

export const MainHeroSection = styled.div`
  background-image: url(${headerbg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 40px;

  /* infoSectionItm */
  .infoSection {
    margin-left: 1rem;
    margin-right: 1rem;
    display: flex;
    gap: 2.5rem;
    margin-top: 1.5rem;

    .infoSectionItm {
      p {
        font-family: "Roboto";
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        letter-spacing: -0.06em;
        color: #1a1a1a;
      }
      p:nth-child(2) {
        margin-top: -1rem;
      }
    }
    @media (max-width: 460px) {
      flex-wrap: wrap;
    }
  }

  /* infoSectionItm */

  /* buttonSection */
  .buttonSection {
    display: flex;
    gap: 1rem;

    margin-top: 1.5rem;

    & > button:nth-child(1) {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 16px;
      width: 243px;
      font-size: 16px;
      background: #d35400;
      border: 1px solid #d35400;
      color: white;
      border-radius: 10px;

      &:hover {
        background: #ff6702;
        transition: all 0.5s;
      }
    }

    & > button:nth-child(2) {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 16px;
      height: 40px;
      background: transparent;
      border: 1px solid #d35400;

      font-family: "Roboto";
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 16px;
      /* identical to box height, or 80% */

      color: #d35400;
      border-radius: 10px;

      &:hover {
        background: #d35400;
        color: White;
        transition: all 0.5s;
      }
    }

    @media (max-width: 767px) {
      & > button:nth-child(1) {
        font-size: 12px;
      }
    }

    @media (max-width: 567px) {
      flex-wrap: wrap;
      & > button {
        width: 100% !important;
      }
      & > button:nth-child(1) {
        font-size: 16px;
      }
    }

    @media (max-width: 460px) {
      & > button:nth-child(2) {
        font-size: 16px;
      }
    }
  }

  /* buttonSection */

  .heroDetailsInfo {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0rem;

    .mainTitle {
      flex: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8.5rem;

      h1 {
        font-family: "Barlow";
        font-style: normal;
        font-weight: 600;
        font-size: 40px;
        color: #1a1a1a;
      }
      @media (max-width: 1400px) {
        flex: 40%;
        h1 {
          font-size: 30px;
        }
      }
      @media (max-width: 1200px) {
        flex: 40%;
        h1 {
          font-size: 22px;
        }
      }
      @media (max-width: 767px) {
        flex: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;

        h1 {
          font-size: 24px;
        }
      }
      @media (max-width: 567px) {
        flex: 30%;
        gap: 0rem;
        h1 {
          font-size: 20px;
        }
      }
      @media (max-width: 520px) {
        flex: 100%;
        h1 {
          text-align: center;
          margin-top: 2rem;
        }
      }
    }

    .byTitle {
      flex: 30%;

      p {
        font-family: "Barlow";
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        color: #1a1a1a;
        transform: translate(-40px, 10px);

        span {
          font-weight: 400;
        }
      }
      @media (max-width: 1400px) {
        p {
          transform: translate(-40px, 5px);
        }
      }

      @media (max-width: 1200px) {
        p {
          font-size: 20px;
        }
      }
      @media (max-width: 767px) {
        p {
          font-size: 20px;
        }
      }
      @media (max-width: 567px) {
        p {
          font-size: 17px;
          > img {
            max-width: 100%;
          }
        }
      }
      @media (max-width: 520px) {
        flex: 100%;

        p {
          text-align: center;
          transform: translate(0px, 5px);
          margin-bottom: 15px;
        }
      }
    }

    .socialICons {
      flex: 20%;

      .socialMain {
        display: flex;
        gap: 2.3rem;
        align-items: center;
        justify-content: center;
        .socialIcon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 1.8rem;
          height: 1.8rem;
          border-radius: 50%;
          cursor: pointer;
          font-size: 18px;

          a {
            text-decoration: none;
            color: rgb(87, 87, 87);
          }

          .dropdown-toggle {
            background-color: transparent;
            border: none;
            color: rgb(87, 87, 87);
            box-shadow: none;
          }

          .dropdown-toggle::after {
            display: none !important;
          }

          &:hover {
            background-color: white;
            color: #d35400;
            box-shadow: none;
          }
        }
        .dropdown-item {
          font-size: 14px;

          &:active {
            background-color: rgb(230, 233, 234);
          }
        }
      }
    }
  }
`;
